<template>
<div id="website" class="flex-c">
    <van-image v-for="(item, index) in imgList" :key="index" :src="item.url" width="10rem" class="flex-self-ctr" />
</div>
</template>

<script>
export default {
    data() {
        return {
            imgList: [{
                url: require('@/assets/groups1.jpg')
            }, {
                url: require('@/assets/groups2.jpg')
            }]
        }
    },
    created() {},
    methods: {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#website {
}
</style>
